import {
  AnyAction,
  createAsyncThunk,
  createSlice,
  PayloadAction,
} from "@reduxjs/toolkit";
import { GetCartInfo, InitiatePaymenrt } from "./publicwebform.request";
import { PaymentCartStateDTO } from "./types";
import { setToastNotification } from "../../../../../../components/ToastNotification/service/toastNotificationSlice";

export const initialState: PaymentCartStateDTO = {
  success: false,
  error: false,
  loading: false,
  data: null,
  paymentInitiateLoading: false,
  paymentInitiateSuccess: false,
  paymentInitiateError: false,
  paymentInitiateData: null,
};

export const getCartInfo = createAsyncThunk(
  "publicwebform/getPaymentCartInfoId",
  async (data: any, { dispatch }) => {
    return GetCartInfo(data)
      .then((response: any) => {
        return response?.data?.data;
      })
      .catch(function (e: any) {
        dispatch(
          setToastNotification({
            message: e?.response?.data?.message,
            type: "error",
            snackOpen: true,
          })
        );
        throw e.response.data;
      });
  }
);

export const initiatePayment = createAsyncThunk(
  "publicwebform/initiatePayment",
  async (data: any, { dispatch }) => {
    return InitiatePaymenrt(data)
      .then((response: any) => {
        return response?.data?.data;
      })
      .catch(function (e: any) {
        dispatch(
          setToastNotification({
            message: e?.response?.data?.message,
            type: "error",
            snackOpen: true,
          })
        );
        throw e.response.data;
      });
  }
);

export const paymentCartSlice = createSlice({
  name: "paymentCard",
  initialState,
  reducers: {
    reset: () => initialState,
    resetPaymentInitiate: (state) => {
      state.paymentInitiateSuccess = false;
      state.paymentInitiateData = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getCartInfo.pending, (state) => {
      state.loading = true;
      state.success = false;
      state.error = false;
    });
    builder.addCase(
      getCartInfo.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.success = true;
        state.error = false;
        state.data = action.payload;
      }
    );
    builder.addCase(getCartInfo.rejected, (state, action: AnyAction) => {
      state.loading = false;
      state.success = false;
      state.error = true;
    });
    builder.addCase(initiatePayment.pending, (state) => {
      state.paymentInitiateLoading = true;
      state.paymentInitiateSuccess = false;
      state.paymentInitiateError = false;
    });
    builder.addCase(
      initiatePayment.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.paymentInitiateLoading = false;
        state.paymentInitiateSuccess = true;
        state.paymentInitiateError = false;
        state.paymentInitiateData = action.payload;
      }
    );
    builder.addCase(initiatePayment.rejected, (state, action: AnyAction) => {
      state.paymentInitiateLoading = false;
      state.paymentInitiateSuccess = false;
      state.paymentInitiateError =
        action?.error?.message || "Something went wrong";
    });
  },
});

export default paymentCartSlice.reducer;
export const { reset, resetPaymentInitiate } = paymentCartSlice.actions;
